import type { UpdateEmailResult } from '@/lib/api/apiTypes';
import { useAuth } from '@/lib/auth/auth';
import { useMutation } from '@tanstack/react-query';

export function useUpdateEmailAddress() {
  const request = useAuth((state) => state.request);
  const setMe = useAuth((state) => state.setMe);

  return useMutation({
    mutationFn: async (email: string) => {
      const result = await request<UpdateEmailResult>('/auth/email/update', {
        method: 'POST',
        body: JSON.stringify({ email }),
      });
      setMe(result.me);
      return result;
    },
  });
}
